(function () {
  "use strict";

  var root = document.querySelector("[data-kw-landing]");

  if (!root || root.dataset.kwInitialized === "true") {
    return;
  }

  root.dataset.kwInitialized = "true";

  var bundleOptions = Array.from(root.querySelectorAll(".bundle-option"));
  var selectedBundle = root.querySelector("#kwSelectedBundle");
  var selectedPrice = root.querySelector("#kwSelectedPrice");
  var stickyName = root.querySelector("#kwStickyName");
  var stickyPrice = root.querySelector("#kwStickyPrice");
  var toast = root.querySelector("#kwToast");
  var demoRange = root.querySelector("#kwDemoRange");
  var demoFrame = root.querySelector("#kwDemoFrame");

  function renderIcons() {
    if (window.lucide && typeof window.lucide.createIcons === "function") {
      window.lucide.createIcons();
    }
  }

  function setBundle(option) {
    bundleOptions.forEach(function (item) {
      item.classList.toggle("is-selected", item === option);

      var radio = item.querySelector('input[type="radio"]');
      if (radio) {
        radio.checked = item === option;
      }
    });

    var name = option.dataset.name;
    var price = option.dataset.price.replace(".", ",") + " \u20AC";

    selectedBundle.textContent = name;
    selectedPrice.textContent = price;
    stickyName.textContent = name;
    stickyPrice.textContent = price + " \u00B7 30 Tage R\u00FCckgabe";
  }

  function showToast(message) {
    if (!toast) {
      return;
    }

    toast.textContent = message;
    toast.classList.add("is-visible");
    window.clearTimeout(showToast.timeout);
    showToast.timeout = window.setTimeout(function () {
      toast.classList.remove("is-visible");
    }, 2100);
  }

  if (
    bundleOptions.length &&
    selectedBundle &&
    selectedPrice &&
    stickyName &&
    stickyPrice
  ) {
    bundleOptions.forEach(function (option) {
      option.addEventListener("click", function () {
        setBundle(option);
      });
    });
  }

  [root.querySelector("#kwAddToBag"), root.querySelector("#kwStickyButton")]
    .filter(Boolean)
    .forEach(function (button) {
      button.addEventListener("click", function () {
        var bundleName = selectedBundle
          ? selectedBundle.textContent
          : "Auswahl";

        showToast(bundleName + " zur Vorschau hinzugef\u00FCgt.");
      });
    });

  if (demoRange && demoFrame) {
    demoRange.addEventListener("input", function () {
      demoFrame.style.setProperty("--position", demoRange.value + "%");
    });
  }

  root.classList.add("kw-ready");

  var themeFooter = document.querySelector(".wrapper-footer");
  var stickyBuy = root.querySelector("#kwStickyBuy");

  if (themeFooter && stickyBuy && "IntersectionObserver" in window) {
    var footerObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          stickyBuy.classList.toggle("kw-hide-for-footer", entry.isIntersecting);
        });
      },
      { threshold: 0.05 }
    );

    footerObserver.observe(themeFooter);
  }

  if ("IntersectionObserver" in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    root.querySelectorAll(".reveal").forEach(function (element) {
      observer.observe(element);
    });
  } else {
    root.querySelectorAll(".reveal").forEach(function (element) {
      element.classList.add("is-visible");
    });
  }

  renderIcons();
})();
